import { useRef, useState } from 'react';
import {
    Card,
    IconButton,
    Stack
} from '@mui/material';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import Iconify from 'src/components/iconify';
import CustomPopover from 'src/components/custom-popover';
import { useSettingsContext } from 'src/components/settings';
import KanbanFiltersPopover from './kanban/kanban-filters';
import { KanbanView } from './kanban/view';

const defaultFilters = {
    name: '',
    role: [],
    status: 'all',
    active: 'all',
};

export default function MarketingBoards() {
    const settings = useSettingsContext();
    const [ filters, setFilters ] = useState(defaultFilters);

    const filterPopoverRef = useRef(null);
    const [ openFilter, setOpenFilter ] = useState(false);

    const handleFilters = (name, value) => {
        setFilters((prev) => ({
            ...prev,
            [ name ]: value,
        }));
    };

    return (
        <>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <CustomBreadcrumbs
                    heading="Marketing Manager"
                    links={ [ { name: '', href: '/' } ] }
                />
                <IconButton
                    ref={ filterPopoverRef }
                    onClick={ () => setOpenFilter(true) }
                >
                    <p style={ { fontSize: '1rem' } } >   Filters</p>
                    <Iconify icon="material-symbols:filter-alt-outline" />
                </IconButton>
            </Stack>

            <CustomPopover
                open={ openFilter }
                onClose={ () => setOpenFilter(false) }
                anchorEl={ filterPopoverRef.current }
                arrow="right-top"
                sx={ { p: 0 } }
            >
                <KanbanFiltersPopover
                    filters={ filters }
                    onFilters={ handleFilters }
                    onClose={ () => setOpenFilter(false) }
                />
            </CustomPopover>

            <Card
                maxWidth={ settings.themeStretch ? false : 'xl' }
                style={ {
                    marginTop: '2rem',
                    borderRadius: '0px',
                    padding: '0.3rem',
                    // boxShadow: 'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px',
                } }
            >
                <KanbanView filters={ filters } />
            </Card>
        </>
    );
}
